<template>
  <div class="ai-warp">
    <div class="header-warp">
      <header class="layoutMaxWidth">
        <h2>多组织管理思想的</h2>
        <h2>ERP系统！</h2>
        <p>规范流程，跟收银机打通的ERP</p>
        <img src="@/assets/img/erp/erp.png" alt />
      </header>
    </div>

    <main>
      <title>ERP系统</title>
      <ul class="layoutMaxWidth">
        <li>
          <img src="@/assets/img/erp/a1.png" alt />
          <h2>多角色</h2>
          <p>提供供应商、采购、仓管、经理、人事、财务等多角色共同完成ERP各项业务</p>
        </li>
        <li>
          <img src="@/assets/img/erp/a2.png" alt />
          <h2>规范流程</h2>
          <p>提供日结、月结规范操作流程</p>
        </li>
        <li>
          <img src="@/assets/img/admin/a3.png" alt />
          <h2>数据报表清晰</h2>
          <p>根据团餐公司的需求提供日报表、月报表和多种数据查询方式</p>
        </li>
      </ul>
    </main>
  </div>
</template>
<script>
export default {
  name: "card",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variable.scss";
.ai-warp {
.header-warp {
    background: url("~@/assets/img/ai/bg1@2x.png") center center no-repeat;
    height: 437px;
  }
  header {
    display: block;
    font-style: italic;
    position: relative;
    h2 {
      padding-top: 144px;
      font-size: 56px;
      padding-bottom: 31px;
    }
    h2:nth-of-type(2){
      padding-top: 10px;
    }
    p {
      letter-spacing: 4px;
      font-size: 20px /*px*/;
      font-weight: 700;
      line-height: 40px;
    }
    img {
      position: absolute;
      top: 71px;
      right: 0px;
      width: 269px;
    }
  }
  main {
    background: url("~@/assets/img/ai/bg@2x.png") center no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 600px;
    title {
      display: inline-block;
      width: 100%;
      font-size: 21px /*px*/;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      color: white;
      padding-top: 89px;
    }
    title::after,
    title::before {
      display: inline-block;
      content: "";
      width: 64px;
      height: 1px;
      background-color: #9c9fa1;
      vertical-align: middle;
      margin-right: 16px;
    }
    title::after {
      margin-right: 0px;
      margin-left: 16px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      margin-top: 61px;
      align-items: center;
      li {
        background-color: white;
        padding: 74px 34px 0;
        margin-right: 17px;
        margin-top: 16px;
        width: 32.5%;
        height: 314px;
        box-sizing: border-box;
        text-align: center;
        img {
          width: 54px;
        }
        h2 {
          font-size: 16px /*px*/;
          color: $primary-color;
          margin-top: 26px;
        }
        p {
          margin-top: 26px;
          font-size: 11px /*px*/;
          line-height: 1.8em;
          text-align: left;
        }
      }
      li:nth-child(3n) {
        margin-right: 0px;
      }
      li:first-child{
        h2{
          margin-top: 34px;
        }
      }
      li:nth-of-type(2){
        p{
          text-align: center;
        }
      }
    }
  }
}
</style>